var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-expansion-panels',[_c('v-expansion-panel',[_c('v-expansion-panel-header',[_vm._v(" Histórico ")]),_c('v-expansion-panel-content',[_vm._v("\n      Histórico de atendimento será carregado aqui\n    ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }